module.exports = __webpack_public_path__ + "img/customer_design_8.a8a767a.webp";